import React from 'react';
import { Section } from './Section';
import { transformationRows } from '../data/tables';
const timeline = [{
  when: 'Week 1',
  what: 'your first calm screening conversation'
}, {
  when: 'Month 3',
  what: 'colleagues start asking you'
}, {
  when: 'Year 1',
  what: 'local physios refer their patients to your classes'
}];
export function Transformation() {
  return <Section background="paper" labelledBy="transformation-heading" data-id="element-254" data-mp="wkbvdtnpp3p1">
      <h2 id="transformation-heading" className="mx-auto max-w-3xl text-center font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[40px]" data-id="element-255" data-mp="wk2482qxkqhr">
        From "please don't mention an injury" to "tell me everything."
      </h2>

      <div className="mt-12 overflow-hidden rounded-2xl border border-sage/15 bg-white shadow-card" data-id="element-256" data-mp="1abyt7xxayk9x">
        <table className="w-full border-collapse text-left" data-id="element-257" data-mp="1fbl7maova6kb">
          <thead data-id="element-258" data-mp="1k9wdybfydyxs">
            <tr data-id="element-259" data-mp="1k9d7bqvr6wz2">
              <th scope="col" className="w-1/2 border-b border-sage/15 px-5 py-4 font-sans text-[12px] font-semibold uppercase tracking-[0.12em] text-ink-muted sm:px-7" data-id="element-260" data-mp="1kay2nipw6jxz">
                Before Screen &amp; Adapt™
              </th>
              <th scope="col" className="w-1/2 border-b border-l border-sage/15 bg-sage-soft px-5 py-4 font-sans text-[12px] font-semibold uppercase tracking-[0.12em] text-sage sm:px-7" data-id="element-261" data-mp="134tvm020yj55">
                With Screen &amp; Adapt™
              </th>
            </tr>
          </thead>
          <tbody data-id="element-262" data-mp="1qvzdslvftnim">
            {transformationRows.map(([before, after]) => <tr key={before} className="border-b border-sage/10 last:border-0" data-id="element-263" data-mp="1m3odvj0p61q2">
                <td className="px-5 py-4 align-top font-sans text-[15px] leading-snug text-ink-muted sm:px-7" data-id="element-264" data-mp="1h5d04x7a772k">
                  {before}
                </td>
                <td className="border-l border-sage/15 bg-sage-soft/40 px-5 py-4 align-top font-sans text-[15px] font-medium leading-snug text-ink sm:px-7" data-id="element-265" data-mp="2eltlyq4tanwj">
                  {after}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <ol className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-266" data-mp="2xnsrj16vr7ik">
        {timeline.map(item => <li key={item.when} className="border-t-2 border-sage pt-4" data-id="element-267" data-mp="2jwxm5yvlb8jq">
            <p className="font-sans text-[12px] font-semibold uppercase tracking-[0.14em] text-sage" data-id="element-268" data-mp="2nyiynj47pkte">
              {item.when}
            </p>
            <p className="mt-2 font-sans text-[15px] leading-snug text-ink-soft" data-id="element-269" data-mp="29y868bn97y64">{item.what}</p>
          </li>)}
      </ol>
    </Section>;
}